import { useId } from 'react';

interface AicostrMarkProps {
  size?: number;
  className?: string;
}

/**
 * D3 "ac" monogram — deep-navy container, blue-to-indigo gradient strokes,
 * accent dot top-right. Single source of truth for the brand mark.
 */
export function AicostrMark({ size = 28, className }: AicostrMarkProps) {
  const id = useId();
  return (
    <svg
      viewBox="0 0 28 28"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={`${id}-bg`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#1e3a8a" />
          <stop offset="100%" stopColor="#1e1b4b" />
        </linearGradient>
        <linearGradient id={`${id}-s`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#93c5fd" />
          <stop offset="100%" stopColor="#a5b4fc" />
        </linearGradient>
      </defs>
      {/* Container */}
      <rect x="1" y="1" width="26" height="26" rx="7" fill={`url(#${id}-bg)`} />
      {/* "a" — open bowl with crossbar */}
      <path
        d="M6,21 C6,13 12,10 12,15 L12,21"
        stroke={`url(#${id}-s)`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="7" y1="17" x2="12" y2="17"
        stroke={`url(#${id}-s)`}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* "c" — open arc */}
      <path
        d="M22,11 C18,8 13,10 13,15 C13,20 18,22 22,19"
        stroke={`url(#${id}-s)`}
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Accent dot — top-right */}
      <circle cx="23" cy="5" r="1.5" fill="#60a5fa" opacity="0.65" />
    </svg>
  );
}
